
import { ModuleActionViewEnum } from "./enums/moduleActionViewEnum";

import * as appsettings          from "./appsettings";
import * as inputs               from "./inputs";
import * as navigation           from "./navigation";
import * as viewmode             from "./viewmode";

declare namespace History {
    interface State {
        data?: any;
        title?: string;
        url?: string;
    }

    interface Adapter {
        bind(element: any, event: string, callback: (e: any) => void): void;
        trigger(element: any, event: string, extra?: any): void;
        extractEventData(key: string, event: any, extra: any): any;
        onDomLoad(callback: () => void): void;
    }

    const Adapter: Adapter;
    function getState(): State;
    function pushState(data: any, title: string, url?: string): void;
    function replaceState(data: any, title: string, url?: string): void;
    function back(): void;
}



/// -1 (go back one step in the history browser)
/// 0 (do nothing)
/// 1 (record new step in history browser)
var currentHistoryAction = 1;


/**
 * This is called once in the home.cshtml
 */
export function Initialize(): void {

    History.Adapter.bind(window, 'statechange', function (e) {

        if (currentHistoryAction === 1) {
            currentHistoryAction = 0;
        }
        else {
            currentHistoryAction = -1;

            // Get current state
            var state = History.getState();

            // Script go back one step
            NavigateTo(state.data.step);
        }
    });

    History.Adapter.bind(window, 'popstate', function (e) {
        var state = History.getState();

        if (state.data.step === 1 && state.data.start === 1 && currentHistoryAction == -1) {
            History.pushState({ step: state.data.step }, state.title, "");
        }
    });
}


/**
 * Browser back button history
 * This will be called everytime the breadcrumb is build with the current list of all steps.
 * @param {any} listTotalBreadcrumbItems
 */
export function RecordBreadcrumbList(listTotalBreadcrumbItems): void {
    if (listTotalBreadcrumbItems.length > 0) {
        var breadcrumbStep = listTotalBreadcrumbItems[(listTotalBreadcrumbItems.length - 1)];

        // Set back (if navigate back)
        if (currentHistoryAction == -1) {
            currentHistoryAction = 0; // was 1 (in Pre-com this is 0)
        }
        else {
            currentHistoryAction = 1;

            // if first
            if (listTotalBreadcrumbItems.length === 1) {
                History.replaceState({ step: breadcrumbStep.Step, start: breadcrumbStep.Start }, breadcrumbStep.Label, "");
                History.pushState({ step: breadcrumbStep.Step, start: breadcrumbStep.Start }, breadcrumbStep.Label, "");
            }
            else {
                History.pushState({ step: breadcrumbStep.Step, start: breadcrumbStep.Start }, breadcrumbStep.Label, "");
            }
        }

        //Last item: <a href="..." class=" k-breadcrumb-link k-disabled" -> Remove k-disabled
        var element = $(".k-breadcrumb-link.k-disabled");
        if (element !== undefined && element !== null) {
            element.removeClass('k-disabled');
        }
    }
}

/**
 * Navigate to a specific step in the breadcrumb.
 * @param {any} desiredStep
 */
export function NavigateTo(desiredStep): void {
    // NavigateTo sets the current session to the desired previous known state (nodeid, module, item). Then reload different panes according to the change.

    function yesAction() {
        $.get(appsettings.getUrl("Breadcrumb/NavigateTo?Step=" + desiredStep), function (data) {

            if (data.NavigatedBack) {

                if (data.DifferentModuleActionView) {
                    viewmode.setViewMode(data.CurrentModuleActionView);
                }

                if (data.DifferentNodeId) {

                    // Set first load (overwrite)
                    navigation.setFirstLoadPage(true);

                    // refresh nodetree
                    $("#contentLayout").data('kendoSplitter').ajaxRequest($("#NodeTree"), appsettings.getLocalUrl("Navigation/GetNodeTree"), null);
                }

                if (data.DifferentModuleId || data.DifferentMenuId || data.DifferentItemId) {
                    viewmode.setViewMode(ModuleActionViewEnum.Overview);
                    // reload module with parameter
                    navigation.navigateToCurrentModuleFromBreadcrumb(data.DifferentModuleId);
                }
            }
        });
    }

    // Check if any input is dirty
    inputs.checkDirtyInput(null, yesAction);
}
